export default {
    toggle: function (selector, prop, from, to) {
        const el = document.querySelector(selector);
        if (getComputedStyle(el)[prop] == from) el.style[prop] = to;
        else el.style[prop] = from;
    },
    tranStatus: function (value) {
        const status = {
            pending: "En attente",
            processing: "En cours",
            completed: "Terminee",
            canceled: "Annulee",
        };
        return status[value];
    },
    getCountryCode: function (countryCode) {
        if (countryCode) {
            return (
                "https://static.dwcdn.net/css/flag-icons/flags/4x3/" +
                countryCode.toLowerCase() +
                ".svg"
            );
        }
    },
    getCountryNameByCode: function (data, Code) {
        for (var prop in data) {
            if (data.hasOwnProperty(prop)) {
                if (data[prop]["code"] === Code) {
                    return data[prop]["name"];
                    break;
                }
            }
        }
    },
    objectToQueryString: function (obj) {
        var str = [];
        var s = document.location.search;
        for (var p in obj)
            if (obj.hasOwnProperty(p)) {
                str.push(
                    encodeURIComponent(p) +
                    "=" +
                    encodeURIComponent(obj[p]).replace(/%2C/g, ",")
                );
            }
        window.history.pushState("", "", "?" + str.join("&"));
    },
    getTimezonesByCode: function (data, Code) {
        for (var prop in data) {
            if (data.hasOwnProperty(prop)) {
                if (data[prop]["code"] === Code) {
                    return data[prop];
                    break;
                }
            }
        }
    },
    QueryStringToobject: function () {
        var search = location.search.substring(1);
        if (search && search.includes("typeuser=")) search = null;
        if (search)
            return JSON.parse(
                '{"' +
                decodeURI(search)
                    .replace(/"/g, '\\"')
                    .replace(/&/g, '","')
                    .replace(/=/g, '":"') +
                '"}'
            );
        else return null;
    },
    getIdbySplit: function (id) {
        let NewId = "";
        if (id) {
            if (id.toString().length >= 24) return id;
            else {
                var lengthId = id.toString().split("-").length;

                if (lengthId == 1) {
                    return id.toString().split("-")[0];
                } else {
                    for (let i in id.split("-")) {
                        if (i != id.split("-").length - 1) {
                            NewId += id.split("-")[i];
                            if (id.split("-").length - 2 != i) NewId += "-";
                        }
                    }
                    return NewId;
                }
            }
        }
    },
    getCurrencyByCode: function (data, Code) {
        for (var prop in data) {
            if (data.hasOwnProperty(prop)) {
                if (data[prop]["code"] === Code) {
                    return data[prop]["currencyCode"];
                    break;
                }
            }
        }
    },
    changeDataWarhouse(data, warhouse, newelement) {
        for (var i in data) {
            if (data[i].warehouse == warhouse.toString()) {
                data[i] = newelement;
                break; //Stop this loop, we found it!
            }
        }
    },
    getElementInArray(data, value) {
        let id_w = value;
        if (value._id) id_w = value._id;
        var result = data.filter(function (o) {
            let whar = o.warehouse;
            if (o.warehouse._id) whar = o.warehouse._id;
            return whar == id_w.toString();
        });
        return result ? result[0] : null; // or undefined
    },
    getAccessPermission: function (user, modelToCheck, accessToCheck) {
        if (user) {
            const permissions = user.role.permissions;
            for (let i in permissions) {
                let model = permissions[i]["model"];
                let access = permissions[i]["access"];

                if (model == modelToCheck) {
                    return access[accessToCheck];
                }
            }
        }
    },
    getPermission(user, name) {
        if (user) {
            const permissions = user.role.permissions;
            for (let i in permissions) {
                let model = permissions[i]["model"];
                let access = permissions[i]["access"];
                //   console.log('Modell ',model);
                if (model == name) {
                    if (access.create || access.read || access.update || access.delete) {
                        // console.log("authorized",model);
                        return true;
                    } else {
                        //console.log("not authorized",model);
                        return false;
                    }
                }
            }
        }
    },
};
